import enLocale from 'element-ui/lib/locale/lang/en'
const en = {
  message: {
    title:"Digital Operation Platform",  
    login: "Login",
    upassword: "Password Is Required",
    password: "Password",
    uname: "Account",
    selectlang:"Please Select Language",
    selectop1:"Chinese",
    selectop2:"English",
    editpassword:"Change Password",
    logout:"Login out",
    oldpassword:"Old Password",
    newpassword:"New Password",
    confirmpassword:"Confirm Password",
    Pleaseenteryouroldpassword:"Please Enter Your Old Password",
    Pleaseenteranewpassword:"Please Enter New Password",
    Pleaseenterthepasswordagain:"Please Enter Password Again",
    Passwordlength:"The Length Of The Password Is 6-18 Bits",
    Inconsistentpasswords:"The two Passwords Are Inconsistent",
    cancel:"Cancel",
    determine:"Confirm",
    username:"User Name",
    Namecn:"Name(CN)",
    Officecode:"OfficeCode",
    mailbox:"Mailbox",
    telephone:"Telephone",
    region:"Region",
    department:"Department",
    state:"State",
    operation:"Operation",
    disable:"Disable",
    enable:"Enable",
    Setrolestorepermissions:"Role Store Permissions Settings ",
    Setroleinterfacepermissions:"Role Permissions Settings",
    Pleaseenterthecontent:"Please Enter The Content",
    homepage:"Home",
    systemmanagement:"System Management",
    Rolemanagement:"Role Management",
    Roleinterfacepermissionconfiguration:"Role Permission Configuration",
    Rolestorepermissionconfiguration:"Role Store Permission Configuration",
    usermanagement:"User Management",
    channel:"Channel",
    Nameen:"Name EN",
    Namecn:"Name CN",
    Addemployee:"Add Employee",
    DownloadFile:"Download List",
    modify:"Modify",
    delete:"Delete",
    Assignpermissions:"Assign Permissions",
    Usermenupermissionconfiguration:"User Menu Permission Configuration",
    Adduser:"Add User",
    market:"Market",
    marketprice:"Market Authority",
    remarks:"Remarks",
    Modifyuser:"Modify User",
    Pleaseselect:"Please Select",
    Pleaseenteralegalemailaddress:"Please Enter Legal Email Address",
    Pleaseenteravalidmobilephonenumber:"Please Enter Valid Mobile Phone Number",
    ALL:"ALL",
    China:"China",
    TaiwanChina:"Taiwan, China",
    HongKongChina:"Hong Kong, China",
    enteroneusername:"Please Enter User Name",
    Thelengthisbetween3and15characters:"The Length Is Between 3 And 15 Characters  3  15",
    Pleaseentertheuserpassword:"Please Enter User Password ",
    Thelengthisbetween6and15characters:"The Length is Between 6 And 15 Characters  6  15",
    Pleaseselectadepartment:"Please Select Department",
    Pleaseselectamarket:"Please Select Market",
    ViewMarket:"Please Select View Market",
    Pleaseenterusermailbox:"Please Enter User Mailbox",
    Pleaseentertheusersmobilephone:"Please Enter Phone Number",
    Failedtogetpermissionlist:"Failed To Get Permission List",
    Allocationsucceeded:"Allocation succeeded",
    allocationfailed:"allocation failed",
    FailedtogetDepartmentlist:"Failed To Get Department List",
    Failedtogetuserinformation:"Failed To Get User Information",
    Operationsucceeded:"Operation Succeeded",
    operationfailed:"Operation Failed",
    Deletesucceeded:"Delete Succeeded",
    Deletionfailed:"Deletion Failed",
    Userinformation:"User Information",
    Storeemployeemanagement:"Store Employee Management",
    Storecode:"Store Code",
    StorenameCN:"Store Name (CN)",
    StorenameeN:"Store Name (EN)",
    contacts:"Contacts",
    region:"Region",
    Setupemployees:"Set Up Employees",
    Failedtogetpermissionlist:"Failed To Get Permission List",
    Inventorymanagement:"Inventory Management",
    Forceinventoryadjustment:"Force Inventory Adjustment",
    Intelligentsearch:"Intelligent ",
    Youcanenterproductnamearticlenumberandstorecodetoquery:"Please Enter Description/Article/BTQCode",//"You can enter product name article number and store code to query,,Code"
    Selectstore:" Store",
    Selecttime:"Time",
    to:"To",
    Startdate:"Start Date", 
    Enddate:"End Date",
    StartMonth:"Start Month", 
    EnddMonth:"End Month",
    Articlenumber:"Article #",
    ProductName:"Description",
    serialnumber:"Serial #",
    Numberofsystems:"Sys Qty",
    Adjustinventory:"Adjust Inventory",
    Fillinadjustmentinformation:"Fill In Adjustment Information",
    Uploadapprovalattachment:"Upload The Approval Attachment",
    shop:"Shop",
    Adjustmenttype:"Adjustment Type",
    Selectfile:"Select File",
    Previousstep:"Previous Step",
    nextstep:"Next Step",
    Addinventory:"Add Inventory",
    Inventoryreduction:"Inventory Reduction",
    yesterday:"Yesterday",
    today:"Today",
    lastweek:"Last Week",
    Thisweek:"This Week",
    Lastmonth:"Last Month",
    Thismonth:"This Month",
    Lastquarter:"Last Quarter",
    Thisquarter:"This Quarter",
    lastyear:"Last Year",
    thisyear:"This Year",
    Pleaseentertheadjustmentquantity:"Please Enter The Adjustment Qty",
    Pleaseselectadjustmenttype:"Please Select Adjustment Type",
    Adjustmentquantitycannotbegreaterthansystemquantity:"Adjustment Qty Cannot Be Greater Than System Qty",
    Filegreaterthan5m:"File Is Greater Than 5M",
    Inventoryadjustmentinprogress:"Inventory Adjustment In Progress...",
    Pleaseloginagain:"Please Log In Again",
    Inventoryadjustment:"Inventory Adjustment",
    Adjustmentquantity:"Adjustment Qty",
    Numberofsystems:"Sys Qty",
    Masterdatamanagement:"Master Data Management",
    Dataupload:"Data upload",
    Selectuploadtype:"Select Upload Type",
    Productmasterdata:"Product Master Data",
    Productunitprice:"Product Unit Price",
    Storeinformation:"Store Information",
    upload:"Upload",
    PushproductmasterinformationtoCRM:"Push Product Master Information To CRM",
    Onlyfilecanbeselected:"Only 1 File Can Be Selected",
    ThefiletypeisnotanXlsxfileorXLSfile:"The File Type Is Not  '.xlsx' or '.xls'",
    Datauploading:"Data Upload",
    Datapushinprogress:"Data Push In Progress",
    Batchmanagement:"Batch Management",
    EctpJDreportupload:"Ectp JD Report Upload ECTP-",
    ECTP:"ECTP",
    JD:"JD",
    Failureinformation:"Failure Information",
    DistributionorderNo:"Distribution Order No",
    Articlenumber:" Article #",
    Sncode:"SNSn Code",
    Orderdeliverytime:"Order Delivery Time",
    quantity:"Qty ",
    Actualpaymentamountofbuyer:"Actual payment amount of buyer",
    Invoiceheader:"Invoice Header",
    street:"Street",
    city:"City",
    EtcpJDReportDownload:"Etcp JD Report Download",
    Pleaseselectastarttimeandanendtime:"Please Select Start Time And End Time",
    Ecommercesales:"E-commerce Sales",
    InventoryreportDownload:"Inventory Report Download",
    stock:"Stock",
    Inventoryreport:"Inventory Report",
    SalesReportDownload:"Sales Report Download",
    sale:"Sale",
    SalesReport:"Sales Report",
    customerservice:"Customer Service",
    Collaborativemanagement:"Collaborative Management",
    Warehousewarehousing:"Warehouse Warehousing",
    Batchnumber:"BatchNo",
    Downloadallstockindetails:"Download All Stock In Details",
    copy:"Copy",
    download:"Download",
    PleaseenterSAPdocNo:"Please Enter SAP Doc No",
    Warehousedelivery:"Warehouse Delivery",
    Receiptvariance:"Receipt Variance",
    Inventoryvariance:"Inventory Variance",
    Inventorynumber:"Inventory Number",
    Countingtime:"Counting Time",
    Inventoryshop:"Inventory Shop",
    applicant:"Applican",
    Inventoryvariance:"Inventory Variance",
    Productname:"Product Name",
    Numberofduplicatedisks:"Number Of Duplicate Disks",
    Differencephoto:"Difference Photo",
    CCreceipt:"CC Receipt",
    Confirmclosing:"Confirm Closing",
    Copysucceeded:"Copy Succeeded",
    Thebrowserdoesnotsupportautomaticreplication:"The Browser Does Not Support Automatic Replication",
    SAPdocNocannotbeblank:"SAP doc No. Cannot Be Blank",
    TherearealsoDNnumbersthathavenotbeenselected:"There Are DN Numbers That Have Not Been Selected",
    Confirmationsuccessful:"Confirmation Successful",
    Savedsuccessfully:"Saved Successfully",
    Remarkscannotbeempty:"Remarks Cannot Be Empty",
    Pleaseselectaproduct:"Please select a product",
    OddNumbers:"Odd Numbers",
    Deliveryshop:"Delivery Shop",
    Returnreason:"Return Reason",
    Storename:"Store Name",
    Deliverytime:"Delivery Time",
    ReceiptNo:"Receipt No",
    Receivingstore:"Receiving Store",
    Receivingtime:"Receiving Time",
    WaybillNo:"Waybill No",
    Shipper:"Shipper",
    Consignee:"Consignee",
    Productarticlenumber:"Product Article #",
    productID:"Product ID",
    Variancedetails:"Variance Details",
    Differencesituation:"Difference Situation",
    Handlingsuggestions:"Handling Suggestions",
    Pleaseenterprocessingsuggestions:"Please Enter Processing Suggestions",
    preservation:"Preservation",
    time:"Time",
    Processingsuggestioncannotbeempty:"Processing Suggestion Cannot Be Empty",

    CCsalesrecordquery:"CC Sales Record Query",
    SalesOrderNo:"Sales Order No",
    Salestime:"Sales Time",
    Salesticket:"Sales Ticket",
    PleaseenternameCn:"Please Enter Chinese Name",
    PleaseenternameEn:"Please Enter Enlish Name",
    Thelengthisbetween1and15characters:"The Length Is Between 1 And 15 Characters",
    Channel:"Channel",
    


    CourierNo:"CourierNo",
    Create:"Create",
    DLVtoWH:"DLV to WH",
    WHCompletein:"WH Complete",
    Post:" Post",
    SHPMNTStatus:"SHPMNT Status",
    PendingforReceipt:"Pending for Receipt",
    WHCompleteintotal:"WH Complete",
    InboundComplete:"Inbound Complete",
    ASNUpload:"ASN Upload",
    DLV :"DLV",
    Invalid:"Invalid",
    MAWB:"InboundDNNo",
    HAWB:"HAWB",
    Warehouse:"Warehouse",
    Inboundtype:"Inboundtype",
    From:"From",
    LOCNAME:"LOCNAME",
    CarrierCompany:"Carrier Company",
    InventoryStatus:"Inventory Status",
    ETD:"ETD",
    ETA:"ETA",
    DateofArrival:"Date of Arrival",
    DLVtoWHdate:"DLV to WH",
    WHCompleteindate:"WH Complete",
    Post:"Post",
    Query:"Query",
    DNNo:"DN NO",
    WHCompleteow:"WH Complete",
    DNStatus:"DN Status",
    DeclarationTotal:"Declaration Total",
    WHCompleteowTotal:"WH Complete Total",
    OutboundCompleteTotal:"Outbound Complete Total",
    NewDN:"New DN",
    OutboundDNNo:"OutboundDNNo",
    WHCompleteowdate:"WH Complete",
    AddASN:"Add ASN",
    ASNDuplicatedata:"ASN Duplicate Data",
    ASNInbounreport:"ASN Inboun report",
    ErrMsg:"ErrMsg",
    ProductDescription:"ProductDescription",
    expBaseQty:"expBaseQty",
    SKU:"SKU",
    SerialNo:"SerialNo",
    WHManagement:"WH Management",
    InboundManagement:"Inbound Management",
    OutboundManagement:"Outbound Management",
     DownloadforInboundReport:"Download for Inbound Report",
     DownloadforOutboundReport:"Download for Outbound Report",
     ASNOutboundreport:"ASN Outbound report",
     StockReceptionfromPOS:" Stock Reception (from POS)",
     StockReceptionfromWarehouse:"Stock Reception (from Warehouse)",
     Menupermissions:"Menu permissions",
     Storepermissions:"Store permissions",
     CurrencyPermission:"Currency Permission",
     IsEnable:"IsEnable",
Enable:"Enable",
Disable:"Disable",
SelectStockablestore:"SelectStockablestore",
SaleRollReport:"Download for SaleRoll Report"
  },
  ...enLocale
};


export default en;


// WEBPACK FOOTER //
// ./src/i18n/lang/en.js